import Fetch from "@/utils/Fetch";
import { useState, useEffect } from "react";
import ManageTrigger from "@/components/trigger/manage-trigger";
import Breadcrumbs from "@/components/breadcrumbs";
import Router, { useRouter } from "next/router";
import { useQuery } from '@tanstack/react-query';
import SettingsMenu from "@/components/settings/menu";
import Helper from "@/utils/helper";
import { createFileRoute } from '@tanstack/react-router'

const EditTriggerPage = () => {

    const router = useRouter();
    const { id } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

    let currPath = '';
    if (Router.router) {
        currPath = Router.router.asPath;
    }

    const { data: triggerData } = useQuery(
        ['trigger', id],
        () => Fetch.get({ url: '/Trigger', params: { id } }),
        { enabled: !!id }
    );
    const [trigger, setTrigger] = useState<any>(null);
    useEffect(() => {
        if (triggerData && !trigger) {
            setTrigger(triggerData);
        }
    }, [triggerData]);

    const onSave = async (triggerId: any) => {
        if (triggerId) {
            const updatedTrigger = await Fetch.get({
                url: '/Trigger',
                params: {
                    id: triggerId
                }
            });

            setTrigger(updatedTrigger);
        }
    };

    return (
        <div className="settings-container">
            <div className="row">
                <SettingsMenu urlPath={currPath} />
                <div className="settings-card">
                    {trigger ?
                        <ManageTrigger
                            triggerToEdit={trigger}
                            module={trigger.Module}
                            onSave={onSave}
                            defaultTriggerName={trigger.Name}
                            defaultSetting1={trigger.TriggerConditions[0].Setting1}
                            defaultSetting2={trigger.TriggerConditions[0].Setting2}
                            modal={false}
                            defaultRuleName={null}
                        />
                        : ""}
                </div>
            </div>

            <style jsx>{`
        .column {
          display: flex;
          flex-direction: column;
          width: 100%;
        }
        .column-margin {
          margin-left: 24px;
        }
        .button-container {
          flex-shrink: 0;
          width: 10rem;
        }
        .button-container :global(.button){
          margin-top: 0.5rem;
        }
        .row {
          display: flex;
          justify-content: space-between;
        }
        .end {
          align-items: flex-end;
        }
        .row.top-gap {
          margin-top: 2.5rem;
        }
        .search-container :global(.search) {
          width: 528px;
        }
        .type-switch {
          position: absolute;
          top: 1.5rem;
          left: 580px;
        }
        a {
          text-decoration: none;
        }
      `}</style>
        </div>
    );

};

export default EditTriggerPage;

export const Route = createFileRoute('/_authenticated/settings/trigger/$id')({ component: EditTriggerPage })
